import algoliasearch from 'algoliasearch';
import { useEffect, useState } from 'react';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useConfigContext } from '@sorare/core/src/contexts/config';
import { joinFiltersWithAnd, sportFilter } from '@sorare/core/src/lib/algolia';

export const useHasInstantBuyCards = (
  sport?: Sport,
  algoliaFilters?: string
) => {
  const [hasInstantBuyCards, setHasInstantBuyCards] = useState<boolean>(false);
  const {
    algoliaCardIndexes: { 'Cards On Sale Ending Soon': cardIndexName },
    algoliaApplicationId,
    algoliaSearchApiKey,
  } = useConfigContext();

  useEffect(() => {
    const client = algoliasearch(algoliaApplicationId, algoliaSearchApiKey);
    const cardsIndex = client.initIndex(cardIndexName);
    const filters = joinFiltersWithAnd([
      'sale.primary:true',
      'sale.type:PrimaryOffer',
      'sale.bundled:false',
      sport && sportFilter(sport),
      'NOT rarity:common',
      algoliaFilters,
    ]);

    cardsIndex
      .search('', { filters, attributesToRetrieve: [] })
      .then(response => {
        setHasInstantBuyCards(response.nbHits > 0);
      });
  }, [
    algoliaApplicationId,
    algoliaFilters,
    algoliaSearchApiKey,
    cardIndexName,
    sport,
  ]);

  return hasInstantBuyCards;
};
